import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import axios from "axios";
import {
  Box,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Tooltip
} from "@mui/material";
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import StepConnector from "@mui/material/StepConnector";
import StepperMst1 from "./StepperMst1";
import StepperMst2 from "./StepperMst2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../../Auth";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../src//GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../../src//GlobalFunction/useModulePermissions';
import axiosInstance from "../../../lib/axios";

const steps = ["Company Details", "Branch Details"];

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#e0e0e0",
    borderTopWidth: 3,
    borderRadius: 1,
    margin: "7px 30px 20px 30px",
  },
}));

const CustomStepIcon = styled("div")(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: "3px solid",
  borderColor: ownerState.active ? "#635bff" : "#e0e0e0",
  borderRadius: "50%",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: ownerState.active ? "#635bff" : "#999",
  fontSize: "1.2rem",
  fontWeight: "bold",
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: "column",
  "& .MuiStepLabel-labelContainer": {
    marginTop: "5px",
  },
});

const Company = () => {
  const location = useLocation();
  const childRef = useRef(null);
  const navigate = useNavigate();
  const [UserLoginId, setUserLoginId] = useState(sessionStorage.getItem('UserId'));
  const [activeStep, setActiveStep] = useState(0);
  const [mode, setMode] = useState("Read");
  const [IsTextFieldDisabled, setTextFieldDisabled] = useState(false);
  const [CompanyData, setCompanyData] = useState([]);
  const [Index, setIndex] = useState(0);
  const [Cities, setCities] = useState([]);
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [AllButtonDisabled, setAllButtonDisabled] = useState(false);
  const [FirstFormData, setFormData] = useState({});
  const [TableData, setTableData] = useState([]);
  const [AllfieldStepperData, setAllfieldStepperData] = useState({});
  const [Status, setStatus] = useState("");
  const [CompanyId, setCompanyId] = useState(-1);
  const [openDialog, setopenDialog] = useState(false);
  const [Flag, setFlag] = useState(false);

  // const permissions = useModulePermissions("Company Master");

  console.log(location);
  // useEffect(()=>{

  // },[Index])

  useEffect(() => {
    const fetch = async () => {
      if (location.state) {
        //function for api call ...
        let companyId = location.state.companyId;
        setCompanyId(companyId);
        await fetchCompanyData(companyId, "R");

        // setMode("view");
        // viewModeDis();
      } else {
        setMode("add");
        addModeDis();
      }
      await fetchCities();
    };

    fetch();
  }, []);

  const viewModeDis = () => {
    setAllTextDisabled(true);
    setAllButtonDisabled(false);
  };

  const addModeDis = () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
  };

  const handleCancel = async () => {
    await UnLock(CompanyId, "MstCo", "CoMstId");
    setopenDialog(false);
  }
  const fetchCities = async () => {
    const response = await axiosInstance.get(
      `PincodeMst/getcitydrp`,

    );
    setCities(response.data.Data);
  };

  const fetchCompanyData = async (companyId, flag) => {

    let allcompanyData = await axiosInstance.post(
      "coMst/RetriveCoMst",
      {
        CoMstId: companyId,
        Flag: flag,
      }
    );

    // let allcompanyData = await axios.post(
    //   `${process.env.REACT_APP_API_URL}coMst/RetriveCoMst`,
    //   {
    //     CoMstId: companyId,
    //     Flag: flag,
    //   },
    //   AuthHeader()
    // );
    console.log("allcompanyData", allcompanyData);
    if (allcompanyData.data.Status === 0) {
      setCompanyData(allcompanyData.data.Data?.CoMstList);
      setCompanyId(allcompanyData.data.Data?.CoMstList[0].CoMstId);
      setStatus(allcompanyData.data.Data?.CoMstList[0].status);
      let step_obj = allcompanyData.data.Data?.CoMstList[0];
      setTableData(allcompanyData.data.Data?.CoMstList[0].CobrMstList);
      setAllfieldStepperData(step_obj);
      setMode("view");
      viewModeDis();
    } else {
      setMode("add");
      addModeDis();
    }

    // await fetchBranchData(companyId, flag);
  };

  // const fetchBranchData = async (companyId, flag) => {
  //   try {


  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}coMst/RetriveCoMst`,
  //       {
  //         CoMstId: parseInt(companyId),
  //         Flag: flag,
  //       },
  //       AuthHeader()
  //     );
  //     let companyBranchdata = response.data.Data?.CoMstList[0].CobrMstList;
  //     setTableData(companyBranchdata);
  //   } catch (error) {
  //     console.log("error");
  //   }
  // };

  const handleAdd = () => {
    addModeDis();
    setMode("add");
    setFlag(false);
    setTableData([]);
    setActiveStep(0);
  };

  const handlePrevClick = () => {
    // if (Index > 0) {
    //   setIndex((prev) => prev - 1);
    // }

    fetchCompanyData(CompanyId, "P");
  };

  const handleNextClick = () => {
    // if (Index < CompanyData.length - 1) {
    //   setIndex((prev) => prev + 1);
    // }
    fetchCompanyData(CompanyId, "N");
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(CompanyId, "MstCo", "CoMstId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        addModeDis();
        setMode("view");
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }

    // setActiveStep(0)
  };

  const stepToNext = (obj) => {
    console.log("backform obj", obj);
    setAllfieldStepperData(obj);

    let newObj = {};
    let newTableData = [...TableData];
    if (mode === "add") {
      newObj.CobrMstId = 0;
      newObj.CobrAdd = obj.CoRegAdd;
      newObj.MainBranch = "1";
      newObj.CobrName = obj.CoName;
      newObj.CobrAbrv = obj.CoAbrv;
      newObj.GSTIN = obj.GSTIN;
      newObj.CobrEmail = obj.CoEmail;
      newObj.PinID = parseInt(obj.PinID);
      newObj.PinCode = obj.PinCode;
      newObj.CityId = parseInt(obj.CityId);
      newObj.DBFLAG = "I";
      newObj.Status = (obj.Status === "1") ? "1" : "0";
      newObj.CobrTel = obj.CoTel;
      newObj.Website = obj.Website;
      newObj.IeCode = obj.IeCode;
      newObj.MsmeNo = obj.MsmeNo;
      newObj.MsmeCat = obj.MsmeCat.trim();
      newObj.MsmeType = obj.MsmeType.trim();
      newObj.Remark2 = obj.Remark2;
      newObj.Remark1 = obj.Remark1;
      newObj.CobrMob = obj.CoMob;
      newObj.CobrLogo = obj.CoLogo;

      // newTableData.push(newObj);
      newTableData[0] = newObj;
      setTableData(newTableData);
    } else {
      let Tabindex = 0;
      TableData[Tabindex].CityId = parseInt(obj.CityId);
      TableData[Tabindex].CobrAdd = obj.CoRegAdd;
      TableData[Tabindex].CobrName = obj.CoName;
      TableData[Tabindex].CobrAbrv = obj.CoAbrv;
      TableData[Tabindex].GSTIN = obj.GSTIN;
      TableData[Tabindex].CobrEmail = obj.CoEmail;
      // newObj.PinCode=obj.PinCode;
      TableData[Tabindex].PinCode = obj.PinCode;
      TableData[Tabindex].PinID = parseInt(obj.PinID);
      TableData[Tabindex].CityId = parseInt(obj.CityId);
      TableData[Tabindex].DBFLAG = "U";
      TableData[Tabindex].Status = (obj.Status === "1") ? "1" : "0";
      TableData[Tabindex].CobrTel = obj.CoTel;
      TableData[Tabindex].Website = obj.Website;
      TableData[Tabindex].IeCode = obj.IeCode;
      TableData[Tabindex].MsmeNo = obj.MsmeNo;
      TableData[Tabindex].MsmeCat = obj.MsmeCat.trim();
      TableData[Tabindex].MsmeType = obj.MsmeType.trim();
      TableData[Tabindex].Remark2 = obj.Remark2;
      TableData[Tabindex].Remark1 = obj.Remark1;
      TableData[Tabindex].CobrMob = obj.CoMob;
      TableData[Tabindex].CobrLogo = obj.CoLogo;
    }
    setActiveStep(1);
  };

  const handleDelete = async () => {

    let Flag = await checkAndLock(CompanyId, "MstCo", "CoMstId");
    console.log(Flag);
    switch (Flag) {
      case 0:
        setopenDialog(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }


  };

  const handleConfirmDelete = async () => {
    if (CompanyId != -1) {

      let response = await axiosInstance.post(
        "coMst/RetriveCoMst",
        {
          CoMstId: String(CompanyId),
          Flag: "D",
        }
      );

      //  toast.success(response.data.Message);
      console.log("response of delete", response);
      if (response.data.Status === 0) {
        toast.success(response.data.Message);
        fetchCompanyData(1, "L");
      } else {
        let arr = response.data.Data;
        let responsestring = "Data Already Exist In";
        if (arr) {
          for (let i = 0; i < arr.length; i++) {
            let lastWord = arr[i]["Msg"].split(" ").pop();
            responsestring += "," + lastWord;
          }

          console.log(responsestring);
          toast.info(responsestring);
        } else {
          toast.info(response.data.Message);
        }
      }
      await UnLock(CompanyId, "MstCo", "CoMstId");
      setopenDialog(false);




      // handleAdd();
      // setMode("view");
      // fetchCompanyData(CompanyId , "P");
    } else {
    }
  };

  const handleMoveBack = () => {
    navigate(`/masters/companytable`);
  };

  const handleStepClick = (step) => {
    if (mode === "view" && !AllButtonDisabled) {
      setActiveStep(step);
    }
  };

  return (
    <Grid>
      <ToastContainer />
      <Box className="form-container">
        <Dialog
          open={openDialog}
          onClose={handleCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
              onClick={handleConfirmDelete}
            >
              Yes
            </Button>
            <Button
              sx={{
                backgroundColor: "#635bff",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  color: "white",
                },
              }}
              onClick={handleCancel}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={2} className="rasidant_grid">
          {/* Header Section */}

          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Tooltip title="Go to Previous" arrow>
    <Button
      variant="contained"
      size="small"
      className="three-d-button-previous"
      sx={{ backgroundColor: "#635BFF", marginRight: { xs: "5px", sm: "10px" }, display: { xs: "none", sm: "block" } }}
      disabled={AllButtonDisabled}
      onClick={handlePrevClick}
    >
      <KeyboardArrowLeftIcon />
    </Button>
  </Tooltip>
  <Tooltip title="Go to Next" arrow>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                className='three-d-button-next'
                disabled={AllButtonDisabled}
                onClick={handleNextClick}
              >
                <NavigateNextIcon />
              </Button>
              </Tooltip>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              {activeStep == 0 ? "Company Master" : "Branch Configuration"}
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Company Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onExit={handleMoveBack}
                readOnlyMode={!AllButtonDisabled}
                onPrevious={handlePrevClick}
                onNext={handleNextClick}
              />
            </Grid>
          </Grid>


          {/* Stepper Section */}
          <Grid item xs={12}>
            <Stepper
              activeStep={activeStep}
              connector={<CustomStepConnector />}
              alternativeLabel
            >
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={() => handleStepClick(index)}
                  style={{ cursor: mode === "view" ? "pointer" : "default" }}
                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        ownerState={{ ...props, active: activeStep === index }}
                      >
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          {/* Content Based on Active Step */}
          <Grid item xs={12}>
            {activeStep === 0 ? (
              <StepperMst1
                index={Index}
                mode={mode}
                CompanyData={CompanyData}
                Cities={Cities}
                AllTextDisabled={AllTextDisabled}
                AllButtonDisabled={AllTextDisabled}
                viewModeDis={viewModeDis}
                addModeDis={addModeDis}
                stepToNext={stepToNext}
                Status={Status} 
                setStatus={setStatus}
                setMode={setMode}
                AllfieldStepperData={AllfieldStepperData}
                Flag={Flag}
                fetchCompanyData={fetchCompanyData}
                setTableData={setTableData}
                CompanyId={CompanyId}

              />
            ) : (
              <StepperMst2
                TableData={TableData}
                mode={mode}
                Cities={Cities}
                setTableData={setTableData}
                AllfieldStepperData={AllfieldStepperData}
                CompanyId={CompanyId}
                setActiveStep={setActiveStep}
                fetchCompanyData={fetchCompanyData}
                viewModeDis={viewModeDis}
                addModeDis={addModeDis}
                setFlag={setFlag}
                IsButtonSubmit={AllTextDisabled}
                UserLoginId={UserLoginId}
                TextDisabledFast={setAllTextDisabled}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {/* <Button
                    variant="contained"
                    size="small"
                    sx={{
                      mr: 10,
                      mr: 10,
                       background  :AllTextDisabled  && 'linear-gradient(290deg, #d4d4d4, #ffffff)',
                       
                        }}
                  
                    
            
                  >
                    Next
                  </Button> */}
            {/* Buttons for form actions */}
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default Company;
